module.exports = new __parcel__URL__("prahlad.0da7ad71.png").toString();